let _ = t => t,
  _t,
  _t2;
import styled from 'styled-components';
import { colors } from '@ovpn-ui/styles';
export const Root = styled.div(_t || (_t = _`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    margin: 0px;

    white-space: nowrap;

    text-align: center;
    vertical-align: middle;
`));
export const Hr = styled.hr(_t2 || (_t2 = _`
    width: 100%;

    margin: 0;

    border-color: ${0};
    border-style: solid;
    border-width: 0px 0px thin;
`), colors.neutralLight);